export default __webpack_public_path__ + "static/media/liquidity.303f1245.png";